import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a8d2a07755b8c0014394b1a_1787828715988_7d0842ab/indianreviewclub/src/app/for-reviewers/components/ForReviewersClient.tsx");
